// extracted by mini-css-extract-plugin
export var root = "z_vb";
export var wrapper = "z_vc";
export var image = "z_vd d_w d_y d_W";
export var crop = "z_vf";
export var round = "z_vg";
export var fixedHeight = "z_vh";